module.exports = __webpack_public_path__ + "static/media/bahawalpur-dark.a9c55333.svg";